<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-toolbar dark color="primary" max-height="60">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form id="form">
          <v-container class="py-0">
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field v-model="newTag.name" @change="populateCode" :label="$i18n.t('Name')" />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="newTag.code" :label="$i18n.t('Code')" />
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-model="newTag.kind"
                  :items="kinds"
                  :label="$i18n.t('Kind')"
                  :disabled="newTag._id != null"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-color-picker
                  v-model="newTag.color"
                  :label="$i18n.t('Color')"
                  :swatches-max-height="80"
                  :show-swatches="false"
                  mode.sync="hex"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn
                  color="blue darken-1"
                  text
                  @click="newTag = {}"
                  v-if="newTag._id"
                  >Reset</v-btn
                >
                <v-btn
                  color="success"
                  class="mr-0"
                  @click="save()"
                  :loading="loading"
                >
                  <h3>
                    {{ newTag._id ? $i18n.t("Update") : $i18n.t("Save") }}
                  </h3>
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="primary--text">{{ $i18n.t("Name") }}</th>
                      <th class="primary--text">{{ $i18n.t("Code") }}</th>
                      <th class="primary--text">{{ $i18n.t("Color") }}</th>
                      <th class="primary--text">{{ $i18n.t("Action") }}</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(tag, index) in allTags" :key="'tag' + index">
                      <td>{{ tag.name }}</td>
                      <td>{{ tag.code }}</td>
                      <td>
                        <span
                          class="tagCircle"
                          :style="{ color: tag.color }"
                        ></span>
                      </td>
                      <td>
                        <v-row>
                          <v-btn
                            small
                            fab
                            text
                            @click="$emit('select', tag)"
                            color="success"
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                          <v-btn small fab text @click="newTag = tag">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <z-confirm-button
                            class="float-right"
                            color="red lighten-1"
                            small
                            fab
                            text
                            dark
                            :loading="loading"
                            :message="
                              $i18n.t('Do you want to delete this tag?')
                            "
                            @click="deleteTag(tag)"
                          >
                            <v-icon>mdi-trash-can-outline</v-icon>
                          </z-confirm-button>
                        </v-row>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doDelete, doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "TagCreate",
  props: {
    label: {
      default: "Tags",
    },
    kind: {
      default: null,
    },
    showDialog: {
      default: false,
    },
    showSelectBtn: {
      default: false,
    },
  },
})
export default class TagCreate extends Vue {
  dialog = false;
  newTag = { kind: this.kind, color: "#FF00FF", name: null, code: null };
  id = null;
  allTags = [];
  kinds = [
    { text: "Vendor", value: 1 },
    { text: "Client", value: 2 },
    { text: "Cargo", value: 3 },
    { text: "Trip", value: 4 },
    { text: "Employee", value: 5 },
    { text: "Tariff", value: 6 },
  ];

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.dialog = val;
  }

  get loading() {
    return common.loading;
  }

  closeDialog() {
    this.dialog = false;
    this.$emit("closeDialog", false);
  }

  populateCode() {
    if (!this.newTag._id)
      this.newTag.code = this.newTag.name;
  }

  async deleteTag(tag) {
    try {
      common.setLoading(true);
      await doDelete(`/api/tag/${tag._id}/delete`);
      this.getAllTags();
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async getAllTags() {
    try {
      common.setLoading(true);
      this.allTags = await doGet(`/api/tag/kind/${this.kind}`);
      common.setLoading(false);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async save() {
    try {
      common.setLoading(true);
      if (typeof this.newTag.color == "object") {
        this.newTag.color = this.newTag.color.hex;
      }
      const response = await doPost("/api/tag/save", this.newTag);
      this.newTag = {
        kind: this.kind,
        color: null,
        name: null,
      };
      common.setLoading(false);
      this.$emit("select", response);
      this.getAllTags();
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async mounted() {
    this.getAllTags();
  }
}
</script>

<style scoped>
.tagCircle:before {
  content: " \25CF";
  font-size: 30px;
}
</style>